<template>
  <div class="w-full bg-white pb-16 tab-content">
    <div
      class="header-content px-4 py-8 mb-4 border-b flex item-center justify-between"
    >
      <h2>{{ $t('message.selfService.taskManager.contact') }}</h2>
      <div class="flex justify-end items-center" v-if="shownSave">
        <zt-button color="dark-300" @click="cancel" class="mr-4" data-vs-button="cancel-contact-edit">
          {{ $t('message.selfService.linkCancel') }}
        </zt-button>
        <zt-button
          @click="saveContactInfo"
          :loader="isLoading"
          :disabled="isDisabled"
          data-vs-button="confirm-contact-edit"
          >
          {{ $t('message.selfService.linkSaveChanged') }}
        </zt-button>
      </div>
    </div>
    <div class="px-4 pb-1" :key="reRenderKey">
      <vue-element-loading
        :active="isLoading"
        spinner="mini-spinner"
        color="#004250"
        style="height: 100%; width: 100%; z-index: 100"
      />
      <div v-if="shownAlert" class="mb-12">
        <zt-alert
          :color="statusAlert"
          :duration="durationAlert"
          close-icon
          filled
          @afterClosed="closeAlert"
          class="message px-3 py-3"
        >
          <div slot="custom-content">
            <div class="flex justify-start items-center">
              <zt-icon
                v-if="iconName"
                :name="iconName"
                class="icon mr-3"
              ></zt-icon>
              <p class="text-lg">{{ messageAlert }}</p>
            </div>
          </div>
        </zt-alert>
      </div>
      <div class="flex">
        <div class="w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            v-model="params.telephone_cel"
            v-validate="{
              regex: /^[0-9a-zA-Z-À-ú-\s]+$/,
              min: 3,
              max: 15,
              numeric: true
            }"
            name="personalPhone"
            class="w-full text-zt-lg"
            :color="errors.has('personalPhone') ? 'danger' : 'primary'"
            :label="$t('message.selfService.taskManager.field.personalPhone')"
            :key="reRenderKey"
            data-vs-input="personal-phone"
            :disabled="readonly"
          />
          <div class="text-zt-danger" v-if="errors.has('personalPhone')">
            <span class="text-zt-danger">
              {{ errors.first('personalPhone') }}
            </span>
          </div>
        </div>
        <div class="w-1/2 ml-4 mt-10 custom-input relative">
          <zt-input
            v-model="params.telephone"
            v-validate="{
              regex: /^[0-9a-zA-Z-À-ú-\s]+$/,
              min: 3,
              max: 15,
              numeric: true
            }"
            name="personalPhoneHouse"
            class="w-full"
            :color="errors.has('personalPhoneHouse') ? 'danger' : 'primary'"
            :label="
              $t('message.selfService.taskManager.field.personalPhoneHouse')
            "
            data-vs-input="personal-phone-house"
            :disabled="readonly"
          />
          <span class="text-zt-danger">
            {{ errors.first('personalPhoneHouse') }}
          </span>
        </div>
      </div>
      <div class="flex">
        <div class="w-1/2 mt-10 mr-4 custom-input relative">
          <zt-input
            v-model="params.telephone_emergency"
            v-validate="{
              regex: /^[0-9a-zA-Z-À-ú-\s]+$/,
              min: 3,
              max: 15,
              numeric: true
            }"
            name="emergencyPhone"
            class="w-full"
            :color="errors.has('emergencyPhone') ? 'danger' : 'primary'"
            :label="$t('message.selfService.taskManager.field.emergencyPhone')"
            data-vs-input="emergency-phone"
            :disabled="readonly"
          />
          <span class="text-zt-danger">
            {{ errors.first('emergencyPhone') }}
          </span>
        </div>
        <div class="w-1/2 ml-4 mt-10 custom-input relative">
          <zt-input
            v-model="params.name_contact_emergency"
            v-validate="{
              required: true,
              regex: /^[0-9a-zA-Z-À-ú-\s]+$/,
              min: 3,
              max: 150
            }"
            name="contactPerson"
            class="w-full"
            :color="errors.has('contactPerson') ? 'danger' : 'primary'"
            :label="$t('message.selfService.taskManager.field.contactPerson')"
            data-vs-input="contact-person"
            :disabled="readonly"
          />
          <span class="text-zt-danger">
            {{ errors.first('contactPerson') }}
          </span>
        </div>
        <div class="w-1/2 ml-4 mt-10 custom-input relative">
          <zt-input
            v-model="params.type_contact"
            v-validate="{
              required: true,
              regex: /^[0-9a-zA-Z-À-ú-\s]+$/,
              min: 3,
              max: 30
            }"
            name="contactType"
            class="w-full"
            :color="errors.has('contactType') ? 'danger' : 'primary'"
            :label="$t('message.selfService.taskManager.field.contactType')"
            data-vs-input="contact-type"
            :disabled="readonly"
          />
          <span class="text-zt-danger">
            {{ errors.first('contactType') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEqual, isEmpty } from 'lodash'
import Employee from '@/apiClient/Employee'
import VueElementLoading from 'vue-element-loading'

const icons = {
  danger: 'exclamation-circle-solid',
  info: 'info-circle-solid'
}
export default {
  name: 'UserContactInfo',
  props: {
    updateFn: {
      type: Function,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueElementLoading
  },
  data: () => ({
    dataContact: {},
    shownSave: false,
    shownAlert: false,
    durationAlert: 10,
    reRenderKey: 0,
    params: {
      telephone: '',
      telephone_cel: '',
      telephone_emergency: '',
      name_contact_emergency: '',
      type_contact: ''
    },
    messageAlert: '',
    cache: {},
    isLoading: false,
    statusAlert: 'info',
    isFirstContact: false
  }),
  computed: {
    iconName() {
      return icons[this.statusAlert]
    },
    isDisabled() {
      return (
        this.errors.has('personalPhone') ||
        this.errors.has('personalPhoneHouse') ||
        this.errors.has('emergencyPhone') ||
        this.errors.has('contactPerson') ||
        this.errors.has('contactType')
      )
    },
    isRequiredContactEmergency() {
      return (
        isEmpty(this.params.telephone_emergency) ||
        isEmpty(this.params.telephone_cel) ||
        isEmpty(this.params.telephone)
      )
    }
  },
  watch: {
    params: {
      handler(newParams) {
        this.shownSave = !isEqual(this.cache, newParams)
      },
      deep: true
    }
  },
  methods: {
    closeAlert() {
      this.shownAlert = false
    },
    cancel() {
      this.infoUpdate()
      this.errors.clear()
      this.shownAlert = false
      this.reRenderKey += 1
    },
    infoUpdate() {
      this.params = { ...this.dataContact }
      this.cache = { ...this.dataContact }
    },
    saveContactInfo() {
      if (
        isEmpty(this.params.type_contact) &&
        isEmpty(this.params.name_contact_emergency)
      ) {
        this.errors.add({
          field: 'contactPerson',
          msg: this.$t('message.selfService.taskManager.fieldRequired')
        })
        this.errors.add({
          field: 'contactType',
          msg: this.$t('message.selfService.taskManager.fieldRequired')
        })
      } else {
        this.isFirstContact ? this.saveContact() : this.editContact()
      }
    },
    async editContact() {
      this.isLoading = true
      const idEmployee = this.params.id
      const payload = {
        telephone: this.params.telephone ? this.params.telephone.trim() : '',
        telephone_cel: this.params.telephone_cel
          ? this.params.telephone_cel.trim()
          : '',
        telephone_emergency: this.params.telephone_emergency
          ? this.params.telephone_emergency.trim()
          : '',
        name_contact_emergency: this.params.name_contact_emergency
          ? this.params.name_contact_emergency.trim()
          : '',
        type_contact: this.params.type_contact
          ? this.params.type_contact.trim()
          : ''
      }
      try {
        await this.employee.updateContactInfo(idEmployee, payload)
        this.shownSave = false
        this.dataContact = payload
        this.durationAlert = 5
        this.messageAlert = this.$t(`message.selfService.statusOk`)
        this.statusAlert = 'info'
        this.shownAlert = true
        this.isLoading = false
      } catch (error) {
        if (error.response.data) {
          this.messageAlert = this.$t(
            `message.selfService.errors.${error.response.data.codes[0].code}`
          )
          this.statusAlert = 'danger'
          this.shownAlert = true
        }
        this.isLoading = false
      }
    },
    async saveContact() {
      this.isLoading = true
      const idEmployee = this.$route.params.id
      const payload = {
        userId: idEmployee,
        telephone: this.params.telephone ? this.params.telephone.trim() : '',
        telephone_cel: this.params.telephone_cel
          ? this.params.telephone_cel.trim()
          : '',
        telephone_emergency: this.params.telephone_emergency
          ? this.params.telephone_emergency.trim()
          : '',
        name_contact_emergency: this.params.name_contact_emergency
          ? this.params.name_contact_emergency.trim()
          : '',
        type_contact: this.params.type_contact
          ? this.params.type_contact.trim()
          : ''
      }
      try {
        await this.employee.createContactInfo(payload)
        this.durationAlert = 5
        this.messageAlert = this.$t(`message.selfService.statusOk`)
        this.statusAlert = 'info'
        this.shownAlert = true
        this.isLoading = false
      } catch (error) {
        if (error.response.data) {
          this.messageAlert = this.$t(
            `message.selfService.errors.${error.response.data.codes[0].code}`
          )
          this.statusAlert = 'danger'
          this.shownAlert = true
        }
        this.isLoading = false
      }
    },
    async getEmployeeContactInfo() {
      const idEmployee = this.$route.params.id
      this.isLoading = true
      try {
        const {
          data: { data }
        } = await this.employee.getContactInfo(idEmployee)
        this.dataContact = data
        await this.infoUpdate()
        this.reRenderKey += 1
        this.isLoading = false
        this.isFirstContact = false
      } catch (error) {
        console.error('ErrorEmployeeContactInfo: ', error)
        if (error.response.status === 404) {
          this.isFirstContact = true
        }
        this.isLoading = false
      }
    }
  },
  mounted() {
    this.getEmployeeContactInfo()
  },
  created() {
    this.employee = new Employee()
  }
}
</script>

<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
.header-content {
  h2 {
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: #4f41a3;
  }
}
::v-deep .zt-input-disabled .zt-input-slot .zt-label[data-v-aea3bcaa] {
  color: #969696;
}
</style>
